import {PerformanceHistoryItem} from "./performance-history-item";
import {Utils} from "../../../../shared/utils/utils";

export class CheckHistoryMapper {

  public static map(data: any): PerformanceHistoryItem {
    let history: PerformanceHistoryItem = new PerformanceHistoryItem();
    history.id = data.id;
    history.score = data.score;
    history.testedUrl = data.testedUrl;
    history.grade = Utils.getPerformanceGrade(data.score);
    history.loadTime = data.fullyLoaded ? data.fullyLoaded.median : 0;
    history.testedAt = data.testedAt ? Utils.getDate(data.testedAt) : null;
    history.pageSize = ( data.pageSize ? data.pageSize : 0 );
    history.requestsCount = ( data.requestsCount ? data.requestsCount : 0 );
    return history;
  }

}
